import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'lib-recategorisation-icon',
  templateUrl: './lib-recategorisation-icon.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LibRecatIconComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
